"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const hopper_1 = require("./hopper");
const summary_stockpile_1 = require("./summary-stockpile");
const silo_1 = require("./silo");
const dailySummaryReducer = (0, redux_1.combineReducers)({
    hopper: hopper_1.dailySummaryHopperReducer,
    stockpileSummary: summary_stockpile_1.stockpileSummaryReducer,
    silo: silo_1.dailySummarySiloReducer
});
exports.default = dailySummaryReducer;
